import { PropertyDataConsortium } from './components/PropertyDataConsortium';

export const StepTwo = () => <PropertyDataConsortium />;
